export default __webpack_public_path__ + "media/choose-missions.0302240b.png";